import React, { Component } from "react";
import { connect } from "react-redux";
import CalculateHoistingForceAndRopeSpeed from "./calculation";
import { updateMotorTypeSelection, validateMotorType } from "../actions/";

class MotorTypeSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calculation: false,
      motor: [],
      show: false,
      selectedMotor: {},
      validMotor: true
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  componentDidUpdate(previousProps) {
    if (this.props.validMotorType !== previousProps.validMotorType) {
      if (!this.props.validMotorType) {
        this.setState({
          validMotor: false
        });
      } else {
        this.setState({
          validMotor: true
        });
      }
    }
    if (
      previousProps.winchType !== this.props.winchType ||
      previousProps.mType !== this.props.mType ||
      previousProps.drumSurface !== this.props.drumSurface ||
      previousProps.previewStatus !== this.props.previewStatus
    ) {
      if (this.props.winchType.orderCode) {
        this.setState({
          show: true
        });
      }
      if (this.props.previewStatus === null) {
        this.setState({
          calculation: true
        });
      }
      if (
        this.props.winchType.orderCode !== previousProps.winchType.orderCode ||
        this.props.motorType.orderCode !== previousProps.motorType.orderCode
      ) {
        this.setState({
          calculation: false
        });
      }
      if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "01" &&
        this.props.drumSurface.orderCode !== "00"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM016, 16 ccm",
                hoistingForce: { value: 12.5, unit: "kN", name: "12,5" },
                hydraulicPressure: { value: 220, unit: "bar" },
                oilFlow: { value: 42, unit: "l/min" },
                ropeSpeed: { value: 40, unit: "m/min" },
                orderCode: "GM016",
                cc: "16ccm gear motor",
                weight: 49
              },
              {
                name: "Gear motor GM021, 21 ccm",
                hoistingForce: { value: 12.5, unit: "kN", name: "12,5" },
                hydraulicPressure: { value: 170, unit: "bar" },
                oilFlow: { value: 55, unit: "l/min" },
                ropeSpeed: { value: 40, unit: "m/min" },
                orderCode: "GM021",
                cc: "21ccm gear motor",
                weight: 50
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "02" &&
        this.props.drumSurface.orderCode !== "00"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM031, 31 ccm",
                hoistingForce: { value: 26.0, unit: "kN", name: "26" },
                hydraulicPressure: { value: 215, unit: "bar" },
                oilFlow: { value: 88, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM031",
                cc: "31ccm gear motor",
                weight: 69
              },
              {
                name: "Gear motor GM036, 36 ccm",
                hoistingForce: { value: 26.0, unit: "kN", name: "26" },
                hydraulicPressure: { value: 185, unit: "bar" },
                oilFlow: { value: 102, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM036",
                cc: "36ccm gear motor",
                weight: 70
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04" &&
        this.props.drumSurface.orderCode !== "00"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM064, 64 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 225, unit: "bar" },
                oilFlow: { value: 170, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "GM064",
                cc: "64ccm gear motor",
                weight: 165
              },
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 165, unit: "bar" },
                oilFlow: { value: 227, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 166
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 255, unit: "bar" },
                oilFlow: { value: 126, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "PM049",
                cc: "49ccm piston motor",
                weight: 160
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "05" &&
        this.props.drumSurface.orderCode !== "00"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 205, unit: "bar" },
                oilFlow: { value: 219, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 186
              },
              {
                name: "Gear motor GM107, 107 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 165, unit: "bar" },
                oilFlow: { value: 272, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "GM107",
                cc: "107ccm gear motor",
                weight: 186.5
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 315, unit: "bar" },
                oilFlow: { value: 122, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "PM049",
                cc: "49ccm piston motor",
                weight: 181
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM016, 16 ccm",
                hoistingForce: { value: 12.5, unit: "kN", name: "12,5" },
                hydraulicPressure: { value: 210, unit: "bar" },
                oilFlow: { value: 44, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM016",
                cc: "16ccm gear motor",
                weight: 49
              },
              {
                name: "Gear motor GM021, 21 ccm",
                hoistingForce: { value: 12.5, unit: "kN", name: "12,5" },
                hydraulicPressure: { value: 160, unit: "bar" },
                oilFlow: { value: 58, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM021",
                cc: "21ccm gear motor",
                weight: 50
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM031, 31 ccm",
                hoistingForce: { value: 26.0, unit: "kN", name: "26" },
                hydraulicPressure: { value: 210, unit: "bar" },
                oilFlow: { value: 90, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM031",
                cc: "31ccm gear motor",
                weight: 69
              },
              {
                name: "Gear motor GM036, 36 ccm",
                hoistingForce: { value: 26.0, unit: "kN", name: "26" },
                hydraulicPressure: { value: 180, unit: "bar" },
                oilFlow: { value: 105, unit: "l/min" },
                ropeSpeed: { value: 42, unit: "m/min" },
                orderCode: "GM036",
                cc: "36ccm gear motor",
                weight: 70
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM016, 16 ccm",
                hoistingForce: { value: 2850, unit: "lbf" },
                hydraulicPressure: { value: 3100, unit: "psi" },
                oilFlow: { value: 12, unit: "gpm" },
                ropeSpeed: { value: 138, unit: "ft/min" },
                orderCode: "GM016",
                cc: "16ccm gear motor",
                weight: 108
              },
              {
                name: "Gear motor GM021, 21 ccm",
                hoistingForce: { value: 2850, unit: "lbf" },
                hydraulicPressure: { value: 2400, unit: "psi" },
                oilFlow: { value: 15, unit: "gpm" },
                ropeSpeed: { value: 138, unit: "ft/min" },
                orderCode: "GM021",
                cc: "21ccm gear motor",
                weight: 110
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM031, 31 ccm",
                hoistingForce: { value: 5900, unit: "lbf" },
                hydraulicPressure: { value: 3100, unit: "psi" },
                oilFlow: { value: 24, unit: "gpm" },
                ropeSpeed: { value: 139, unit: "ft/min" },
                orderCode: "GM031",
                cc: "31ccm gear motor",
                weight: 152
              },
              {
                name: "Gear motor GM036, 36 ccm",
                hoistingForce: { value: 5900, unit: "lbf" },
                hydraulicPressure: { value: 2600, unit: "psi" },
                oilFlow: { value: 28, unit: "gpm" },
                ropeSpeed: { value: 139, unit: "ft/min" },
                orderCode: "GM036",
                cc: "36ccm gear motor",
                weight: 154
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM064, 64 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 215, unit: "bar" },
                oilFlow: { value: 176, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "GM064",
                cc: "64ccm gear motor",
                weight: 165
              },
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 160, unit: "bar" },
                oilFlow: { value: 236, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 166
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 45.0, unit: "kN", name: "45" },
                hydraulicPressure: { value: 245, unit: "bar" },
                oilFlow: { value: 131, unit: "l/min" },
                ropeSpeed: { value: 47, unit: "m/min" },
                orderCode: "PM049",
                cc: "49ccm piston motor",
                weight: 160
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 195, unit: "bar" },
                oilFlow: { value: 230, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 186
              },
              {
                name: "Gear motor GM107, 107 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 155, unit: "bar" },
                oilFlow: { value: 287, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "GM107",
                cc: "107ccm gear motor",
                weight: 186.5
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 55.0, unit: "kN", name: "55" },
                hydraulicPressure: { value: 295, unit: "bar" },
                oilFlow: { value: 128, unit: "l/min" },
                ropeSpeed: { value: 46, unit: "m/min" },
                orderCode: "PM049",
                cc: "49ccm piston motor",
                weight: 181
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 12300, unit: "lbf" },
                hydraulicPressure: { value: 2800, unit: "psi" },
                oilFlow: { value: 61, unit: "gpm" },
                ropeSpeed: { value: 152, unit: "ft/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 410
              },
              {
                name: "Gear motor GM107, 107 ccm",
                hoistingForce: { value: 12300, unit: "lbf" },
                hydraulicPressure: { value: 2300, unit: "psi" },
                oilFlow: { value: 76, unit: "gpm" },
                ropeSpeed: { value: 152, unit: "ft/min" },
                orderCode: "GM107",
                cc: "107ccm gear motor",
                weight: 411
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 12300, unit: "lbf" },
                hydraulicPressure: { value: 4300, unit: "psi" },
                oilFlow: { value: 34, unit: "gpm" },
                ropeSpeed: { value: 152, unit: "ft/min" },
                orderCode: "PM049",
                cc: "49ccm gear motor",
                weight: 399
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState(
          {
            motor: [
              {
                name: "Gear motor GM064, 64 ccm",
                hoistingForce: { value: 10100, unit: "lbf" },
                hydraulicPressure: { value: 3100, unit: "psi" },
                oilFlow: { value: 47, unit: "gpm" },
                ropeSpeed: { value: 155, unit: "ft/min" },
                orderCode: "GM064",
                cc: "64ccm gear motor",
                weight: 364
              },
              {
                name: "Gear motor GM085, 85 ccm",
                hoistingForce: { value: 10100, unit: "lbf" },
                hydraulicPressure: { value: 2300, unit: "psi" },
                oilFlow: { value: 63, unit: "gpm" },
                ropeSpeed: { value: 155, unit: "ft/min" },
                orderCode: "GM085",
                cc: "85ccm gear motor",
                weight: 366
              },
              {
                name: "Piston motor PM049, 49 ccm",
                hoistingForce: { value: 10100, unit: "lbf" },
                hydraulicPressure: { value: 3500, unit: "psi" },
                oilFlow: { value: 35, unit: "gpm" },
                ropeSpeed: { value: 155, unit: "ft/min" },
                orderCode: "PM049",
                cc: "49ccm gear motor",
                weight: 353
              }
            ]
          },
          () => {
            if (this.props.motorType) {
              var sameMotor = false,
                motor = {};
              this.state.motor.map((mot, index) => {
                if (mot.orderCode === this.props.motorType.orderCode) {
                  sameMotor = true;
                  motor = mot;
                }
              });
              if (sameMotor) {
                this.props.onMotorTypeSelect(motor);
              } else {
                this.props.onMotorTypeSelect("");
                var ele = document.getElementsByName("motor_type");
                for (var i = 0; i < ele.length; i++) ele[i].checked = false;
              }
            }
          }
        );
      }
    }
  }

  handleOnchange = motor => {
    this.props.onMotorTypeSelect(JSON.parse(motor.target.value));
    this.props.validateMotorType(true);
    this.setState({
      calculation: true,
      selectedMotor: JSON.parse(motor.target.value)
    });
  };

  render() {
    var motors = this.state.motor.map((mot, index) => {
      return (
        <div
          className={index === 2 ? "col-md-6 motor3" : "col-md-6"}
          key={index}
        >
          <label>
            <input
              type="radio"
              value={JSON.stringify(mot)}
              defaultChecked={
                this.props.motorType.orderCode === mot.orderCode ? true : false
              }
              name="motor_type"
            />{" "}
            {mot.name}
          </label>
          <br />
          Hoisting force{" "}
          {(mot.hoistingForce.name
            ? mot.hoistingForce.name
            : mot.hoistingForce.value) +
            " " +
            mot.hoistingForce.unit}{" "}
          at hydraulic pressure{" "}
          {mot.hydraulicPressure.value + " " + mot.hydraulicPressure.unit}
          <br />
          Rope speed {mot.ropeSpeed.value + " " + mot.ropeSpeed.unit} at oil
          flow {mot.oilFlow.value + " " + mot.oilFlow.unit}
        </div>
      );
    });

    return (
      <div>
        {this.state.show && (
          <div>
            <div className="field-top">Motor type and displacement</div>
            <div className="selection-body">
              <p>
                Please select the suitable motor according the hydraulic data of
                your system.
              </p>
              {this.state.validMotor === false && (
                <p className="warning">Motor type is required.</p>
              )}
              <div className="row" onChange={this.handleOnchange}>
                {motors}
              </div>
              {this.state.calculation && <CalculateHoistingForceAndRopeSpeed />}
            </div>
          </div>
        )}
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    motorType: state.motorType,
    drumSurface: state.drumSurface,
    previewStatus: state.previewStatus,
    validMotorType: state.validMotorType
  };
};

const mapActionsToProps = {
  onMotorTypeSelect: updateMotorTypeSelection,
  validateMotorType: validateMotorType
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(MotorTypeSelection);



// WEBPACK FOOTER //
// ./src/components/mototType.js